import clsx from 'clsx'
import {
  Text,
  Avatar,
} from '.'
import {
  AccountCircle as AvatarIcon,
} from '@material-ui/icons'
import useStyles from './styles'

export const Header = ({
  isFetching,
  avatar,
  titleVariant = "title1",
  title,
  subtitle,
  sideContent,
  direction = "normal",
  useColumnLayout = false,
  borderBottom = false
}) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.header, useColumnLayout && classes.headerCenteredContent, borderBottom && classes.headerBorderBottom)}>
      <div className={clsx(
        classes.headerMainContent,
        direction === "centered" && classes.headerCenteredContent
      )}>
        {avatar &&
          <div className={clsx(classes.headerAvatarWrapper, useColumnLayout && classes.centeredAvatar)}>
            {avatar === "contact" ?
              <AvatarIcon style={{ fontSize: "7rem", color: "#ddd" }} />
            :
              <Avatar size={12}>{avatar}</Avatar>
            }
          </div>
        }
        <div className={clsx(
          classes.headerTitle,
          avatar && classes.headerTitleWithAvatar,
          useColumnLayout && classes.centeredTitle
        )}>
          <Text variant="h4" className={titleVariant == "title2" ? classes.pageTitle2Text : classes.pageTitleText} gutterBottom={Boolean(subtitle)}>
            {title}
          </Text>
          {subtitle &&
            <div className={classes.headerSubtitle}>
              {subtitle}
            </div>
          }
        </div>
      </div>
      {sideContent &&
        <div className={classes.headerSideContent}>
          {sideContent}
        </div>
      }
    </div>
  )
}

export default Header